import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, Download, Landmark, PenLine } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { MandatPdfApercu, telechargerMandat } from './MandatPdfApercu';
import { EcheancesMandat } from './EcheancesMandat';
import { HistoriqueMandats } from './HistoriqueMandats';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const eur = (c) => ((c || 0) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

/** Espace membre : mes mandats SEPA (aperçu + téléchargement). */
export default function MesMandatsSEPA({ getAuthHeader }) {
  const [mandats, setMandats] = useState([]);
  const [apercu, setApercu] = useState(null);

  useEffect(() => {
    axios.get(`${API}/sepa-stripe/membre/mandats`, { headers: getAuthHeader() })
      .then((r) => setMandats(r.data?.mandats || []))
      .catch(() => setMandats([]));
  }, [getAuthHeader]);

  if (!mandats.length) return null;
  const url = (m) => `/sepa-stripe/membre/mandats/${m.id}/pdf`;

  return (
    <Card className="border-l-4 border-l-[#0a3d62]" data-testid="mes-mandats-sepa">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2"><Landmark className="h-4 w-4 text-[#0a3d62]" /> Mes mandats SEPA</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {mandats.map((m) => (
          <div key={m.id} className="space-y-2">
          <div className="flex items-center gap-2 rounded-lg border border-slate-200 p-2.5" data-testid={`mon-mandat-${m.id}`}>
            <div className="min-w-0 flex-1">
              <p className="text-xs font-mono text-slate-600 truncate">{m.rum}</p>
              <p className="text-sm font-semibold text-slate-800" data-testid={`mon-mandat-dispositif-${m.id}`}>{m.dispositif_precis || m.dispositif} · {eur(m.montant_cents)}</p>
              <span className={`inline-block mt-0.5 px-2 py-0.5 rounded text-[10px] font-bold ${m.status === 'signe' ? 'bg-emerald-600 text-white' : 'bg-[#DEA900] text-[#0a3d62]'}`} data-testid={`mon-mandat-statut-${m.id}`}>
                {m.status === 'signe' ? 'Signé' : 'Non signé'}
              </span>
            </div>
            {m.status === 'en_attente_signature' && (m.lien_signature_url || m.stripe_setup_url) && (
              <a href={m.lien_signature_url || m.stripe_setup_url} target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 rounded-lg bg-[#DEA900] px-3 py-2 text-xs font-bold text-[#0a3d62] transition-colors hover:bg-[#f5cc3e]" data-testid={`mon-mandat-signer-${m.id}`}>
                <PenLine className="h-3.5 w-3.5" /> Signer mon mandat
              </a>
            )}
            <button type="button" title="Voir le mandat" onClick={() => setApercu(m)} className="p-2 rounded hover:bg-slate-100 text-[#0a3d62]" data-testid={`mon-mandat-voir-${m.id}`}><Eye className="h-4 w-4" /></button>
            <button type="button" title="Télécharger le mandat" onClick={() => telechargerMandat(url(m), getAuthHeader(), `Mandat_SEPA_${m.rum}.pdf`)} className="p-2 rounded hover:bg-slate-100 text-[#0a3d62]" data-testid={`mon-mandat-telecharger-${m.id}`}><Download className="h-4 w-4" /></button>
          </div>
          {m.status === 'signe' && <EcheancesMandat mandatId={m.id} headers={getAuthHeader()} />}
          </div>
        ))}
      </CardContent>
      <MandatPdfApercu mandat={apercu} url={apercu ? url(apercu) : ''} headers={getAuthHeader()} onClose={() => setApercu(null)} />
      <HistoriqueMandats headers={getAuthHeader()} />
    </Card>
  );
}
